import "./style.css";
import { jsxs as f, jsx as p } from "react/jsx-runtime";
import { c as l } from "../../__shared__/index.js";
import m from "../../controls/PriceLabel/PriceLabel.js";
const w = "_wrapper_yxv1v_1", _ = "_wrapperColumn_yxv1v_9", N = "_priceFirst_yxv1v_15", a = {
  wrapper: w,
  wrapperColumn: _,
  priceFirst: N
};
function F({
  price: i = void 0,
  strikethroughPrice: r = void 0,
  layoutMode: c = "row",
  layoutOrder: v = "price-last",
  locale: o,
  currencyCode: s,
  priceFormatter: e
}) {
  const d = i == null || Number.isNaN(i) || i === 1 / 0, u = r == null || Number.isNaN(r) || r === 1 / 0, n = d ? "" : e(i, o, s), t = u ? "" : e(r, o, s);
  return !n && !t ? null : /* @__PURE__ */ f(
    "div",
    {
      className: l(
        a.wrapper,
        c === "column" ? a.wrapperColumn : void 0
      ),
      children: [
        t && /* @__PURE__ */ p(
          m,
          {
            formattedPrice: t,
            variant: "strikethrough",
            class: l(
              v === "price-first" ? a.priceFirst : null
            )
          }
        ),
        n && /* @__PURE__ */ p(
          m,
          {
            formattedPrice: n,
            variant: r ? "reduced" : "default"
          }
        )
      ]
    }
  );
}
export {
  F as default
};
//# sourceMappingURL=PriceContainer.js.map
